var COMMUNITIES = [
  {
    id: '001',
    name: {
      es: 'Tinto',
      en: 'Tinto',
    },
    provinces: [
      {
        id: '001-001',
        ciudad: {
          x: '5.2%',
          y: '20.3%',
          vino: 'D.O Rías Baixas',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '19.4%',
          y: '19.3%',
          vino: 'D.O Bierzo',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '21.4%',
          y: '34.8%',
          vino: 'D.O Arribes del Duero',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '29.6%',
          y: '28.2%',
          vino: 'Vinos de la Tierra de Castilla y León y Tierra de León',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '23.8%',
          y: '41.2%',
          vino: 'D.O Sierra de Salamanca',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '19%',
          y: '60.2%',
          vino: 'D.O Ribera del Guadiana',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '40.7%',
          y: '43.8%',
          vino: 'D.O Madrid',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      /*{
        id: '001-001',
        ciudad: {
          x: '41.3%',
          y: '51.4%',
          vino: 'D.O de Castilla La Mancha',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },*/
      {
        id: '001-001',
        ciudad: {
          x: '53.3%',
          y: '33.7%',
          isBlack: true,
          vino: 'D.O Catalayud',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '56.6%',
          y: '33.7%',
          vino: 'D.O Cariñera',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '56.6%',
          y: '33.7%',
          vino: 'D.O Cariñera',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '69.9%',
          y: '35.7%',
          vino: 'D.O Terra Alta',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '76.9%',
          y: '32%',
          vino: 'D.O Tarragona',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '51.6%',
          y: '56.6%',
          isBlack: true,
          vino: 'IGP Vinos de la Tierra de Castilla',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '57.8%',
          y: '53%',
          isBlack: true,
          vino: 'D.O Utiel-Requena',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '54.7%',
          y: '60%',
          vino: 'D.O Manchuela',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-001',
        ciudad: {
          x: '58.6%',
          y: '66%',
          vino: 'D.O Jumilla',
          isBlack: true,
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
    ],
  },
];

let arrayOrder = [];

async function getCommunities() {
  await fetch(mapSvgUrl)
    .then(response => response.text())
    .then(svg => {
      const mapContainer = document.getElementById('mapContainer');
      mapContainer.innerHTML = svg;
    });

  COMMUNITIES.forEach((community, i) => {
    community.provinces.forEach(variety => {
      arrayOrder.push(variety.order);

      const capitalPosition = variety.ciudad;
      const vineName = variety.ciudad.vino;

      const vineIcon = document.createElement('div');
      const vineIconSpam = document.createElement('span');
      vineIconSpam.className = 'vineIconSpam';

      vineIcon.className = 'vineIcon';
      vineIcon.style.position = 'absolute';
      vineIcon.style.left = capitalPosition.x;
      vineIcon.style.top = capitalPosition.y;

      document.querySelector('#mapContainer').appendChild(vineIcon);
      vineIcon.appendChild(vineIconSpam);
      vineIconSpam.textContent = vineName;

      if (capitalPosition.isBlack) {
        vineIcon.style.backgroundColor = 'black';
        vineIcon.classList.add('redWine');
      } else {
        vineIcon.style.backgroundColor = '#d6b36a';
        vineIcon.classList.add('whiteWine');
      }

      vineIcon.addEventListener('click', () => {
        const targetId = variety.ciudad.vino;
        window.location.href = `#${targetId}`;
      });
    });
  });
}

getCommunities();

const vineIcons = document.querySelectorAll('.vineIcons');
vineIcons.forEach(icon => {
  icon.addEventListener('click', () => {
    const targetId = variety.ciudad.vino;
    window.location.href = `#${variety.ciudad.vino}`;
  });
});

//Buttons Logic
const redButton = document.querySelector('#redButton');
const whiteButton = document.querySelector('#whiteButton');
const allButton = document.querySelector('#allButton');

redButton.addEventListener('click', redWines);
whiteButton.addEventListener('click', whiteWines);
allButton.addEventListener('click', allWines);

function redWines() {
  document.querySelectorAll('.redWine').forEach(wine => {
    wine.classList.add('d-block');
    wine.classList.remove('d-none');
  });

  document.querySelectorAll('.whiteWine').forEach(wine => {
    wine.classList.add('d-none');
    wine.classList.remove('d-block');
  });
}

function whiteWines() {
  document.querySelectorAll('.redWine').forEach(wine => {
    wine.classList.add('d-none');
    wine.classList.remove('d-block');
  });

  document.querySelectorAll('.whiteWine').forEach(wine => {
    wine.classList.add('d-block');
    wine.classList.remove('d-none');
  });
}

function allWines() {
  document.querySelectorAll('.redWine').forEach(wine => {
    wine.classList.add('d-block');
    wine.classList.remove('d-none');
  });

  document.querySelectorAll('.whiteWine').forEach(wine => {
    wine.classList.add('d-block');
    wine.classList.remove('d-none');
  });
}

window.addEventListener('load', allWines);
